import request from '../request';

const server = {
  // 分页查询销售联系人和财务联系人
  pageCompanyContacts(params) {
    return request.post(
      'user-center/companyContacts/pageCompanyContacts',
      params
    );
  },
  // 保存或更新联系人信息
  saveContactDetail(params) {
    return request.post(
      'user-center/companyContacts/saveContactDetail',
      params
    );
  },
  // 用户区域
  queryByParentId(params) {
    return request.post('/user-center/area/queryByParentId', params);
  },
  // 删除联系人
  deleteContact(params) {
    return request.post('/user-center/companyContacts/deleteContact', params);
  },

  // 获取联系人详情
  getContactDetail(params) {
    return request.post(
      '/user-center/companyContacts/getContactDetail',
      params
    );
  },
  // 模糊查询员工账号|| 联系人姓名
  typeAheadContactMemberInfo(params) {
    return request.post(
      '/user-center/companyContacts/typeAheadContactMemberInfo',
      params
    );
  },
  // 查询类目
  queryMdmTreeDataList(params) {
    return request.post(
      '/product/skuManagement/api/queryMdmTreeDataList',
      params
    );
  },
  // 查询区域
  listChinaProvinceAndCity(params) {
    return request.post('/user-center/area/listChinaProvinceAndCity', params);
  },
};
export default server;
